import { createSelector } from 'reselect'
import { State } from 'index'

const checkoutSelector = (state: State) => state.checkout

export const getOrders = createSelector([checkoutSelector], (state) => state.orders)
export const getOrderTimes = createSelector([checkoutSelector], (state) => state.orderTimes)
